import React from 'react';
import { Link, SwitchCheckbox, Typography } from '@klarna/bubble-ui';
import { TermsAndConditionsPerMarket } from '@/bpc/types/BpcPayload';
import styled from 'styled-components';
export const TERMS_AND_CONDITIONS_TRANSLATION_KEY =
  'products-fe.components.product_prices_card.pricing_annex.before_link';

const AgreementWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

type TermsAndConditionsProps = {
  termsData: TermsAndConditionsPerMarket[];
  selectedTerms: string[];
  hasAcceptedTerms: boolean | undefined;
  isLoading: boolean;
  onChange: (termUrl: string) => () => void;
  t: any; // TODO: find/enable global type for 't'
};

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
  termsData,
  ...props
}: TermsAndConditionsProps) => {
  if (!termsData) {
    return null;
  }
  if (!termsData.length) {
    return null;
  }

  return (
    <>
      {termsData.map(term => (
        <Term key={term.fallback_label} term={term} {...props} />
      ))}
    </>
  );
};

type TermProps = Omit<TermsAndConditionsProps, 'termsData'> & { term: TermsAndConditionsPerMarket };
const Term: React.FC<TermProps> = ({
  term,
  selectedTerms,
  hasAcceptedTerms,
  isLoading,
  onChange,
  t,
}: TermProps) => {
  const isSelected = selectedTerms.includes(term.url);
  const isChecked = hasAcceptedTerms || isSelected;

  return (
    <AgreementWrapper>
      <SwitchCheckbox
        key={term.url}
        onChange={onChange(term.url)}
        checked={isChecked}
        disabled={hasAcceptedTerms || isLoading}
      />
      <Typography textToken="text-style/text/super-paragraphs/body/regular">
        {t(TERMS_AND_CONDITIONS_TRANSLATION_KEY)}
        &nbsp;
        {/* @ts-expect-error: FIXME */}
        <Link inParagraph href={term.url} target="_blank">
          {t(term.label, {}, term.fallback_label)}
        </Link>
      </Typography>
    </AgreementWrapper>
  );
};

export default TermsAndConditions;
